"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = void 0;
exports.path = '/service-center-node-consumables-status-get';
//# sourceMappingURL=index.js.map